import { render, staticRenderFns } from "./DownloadCenter.vue?vue&type=template&id=704477f8&"
import script from "TS/components/home/DownloadCenter.component?vue&type=script&lang=js&"
export * from "TS/components/home/DownloadCenter.component?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports